
import { DOWNLOAD_COMMON_FULL_S3_URL, KEEP_ALIVE_URL, PAYEE_APPROVE_URL, PAYER_APPROVE_URL, RESON_CODES_APPROVE_URL, SESSION_LOGOUT } from '../../api';
import axiosInstance from './../../axiosInstance';


// dashboard 
export const approveFunction = (id, type) => onResponse => {
    let url = null
    let dic = null
    if (type === 'payee_approve') {
        url = PAYEE_APPROVE_URL
        dic = { payee: id }
    } else if (type === 'payer_approve') {
        dic = { payer: id }
        url = PAYER_APPROVE_URL
    } else if (type === 'reson_codes_approve') {
        dic = { reasoncode: id }
        url = RESON_CODES_APPROVE_URL
    }
    try {
        axiosInstance.post(url, dic)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {
    }

};
export const keepAliveApi = () => onResponse => {
    try {
        axiosInstance.get(KEEP_ALIVE_URL)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {
    }

};

export const downloadCommonFullS3File = (payload) => onResponse => {
    try {
        axiosInstance.post(DOWNLOAD_COMMON_FULL_S3_URL, payload)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.error(err);
                onResponse(err);
            });
    } catch (error) {
        console.error(error);
    }
};

export const keepAliveApiAsync = async (props) => {
    try {
        const response = await axiosInstance.get(KEEP_ALIVE_URL, {
        customData: {
            isKeepAliveLogin: true,
            source: "keepAliveCall",
        },
    });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const logoutAsync = async (props) => {
    try {
        const response = await axiosInstance.post(SESSION_LOGOUT, props);
        return response.data;
    } catch (error) {
        throw error;
    }
};
